<template>
  <el-container class="avue-contail">
    <el-header :height="headerHeight" class="avue-tabs">
      <!-- 顶部导航栏 -->
      <top />
      <div class="logo-container">
        <router-link to="/index">
          <img src="../../assets/image/icons/logo.png" alt />
        </router-link>
      </div>
      <custom-menu></custom-menu>
    </el-header>
    <el-main class="avue-main main">
      <!-- 主体视图层 -->
      <keep-alive>
        <transition name="fade-transverse">
          <router-view class="avue-view" v-if="$route.meta.keepAlive" />
        </transition>
      </keep-alive>
      <transition name="fade-transverse">
        <router-view class="avue-view" v-if="!$route.meta.keepAlive" />
      </transition>
    </el-main>
    <el-footer style="height:auto">
      <div style="text-align: center">
      <span
        >版权所有：中国化学工程集团(股份)有限公司 |
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >京ICP备17025820号-5</a
        >
         | 版本号：{{this.versionNumber}}<!-- | 技术支持：北京赛鼎科技有限公司 --></span
      >
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import layout from "@/const/layout";
import top from "./top/";
import menu from "./menu/";
import { validatenull } from "@/util/validate";
import DateUtil from "@/util/date.js";
import { setStore, getStore } from "@/util/store.js";

export default {
  components: {
    top,
    customMenu: menu,
  },
  name: "index",
  data() {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: layout.asideWidth + "px",
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: layout.asideWidthCollapse + "px",
      // 头部高度
      headerHeight: layout.headerHeight + "px",
      //刷新token锁
      refreshLock: false,
      //刷新token的时间
      refreshTime: "",
    };
  },
  created() {
    //实时检测刷新token
    this.refreshToken();
  },
  mounted() {},
  computed: mapGetters(["isLock", "isCollapse", "website", "versionNumber"]),
  props: [],
  methods: {
    // 实时检测刷新token
    refreshToken() {
      this.refreshTime = setInterval(() => {
        const token = getStore({
          name: "token",
          debug: true,
        });
        const date = DateUtil.calcDate(token.datetime, new Date().getTime());
        if (validatenull(date)) return;
        if (!(date.seconds >= this.website.tokenTime) && !this.refreshLock) {
          this.refreshLock = true;
          this.$store
            .dispatch("RefeshToken")
            .then((res) => {
              clearInterval(this.refreshTime);
            })
            .catch((err) => {
              this.refreshLock = false;
            });
        }
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.avue-contail {
  height: 100%;
  background: url("../../assets/image/icons/background.png") 0 0 no-repeat;
  background-size: 100% auto;
}
.avue-main {
  width: 1220/1366*100+vw;
  position: relative;
  height: 100%;
  margin: 0 auto;
  overflow-x:hidden;
  padding: 0;
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: rgba(144, 146, 152, 0.3);
  }
  ::-webkit-scrollbar-track-piece {
      background-color: transparent;
  }
}
.logo-container {
  width: 183px;
  height: 32px;
  position: absolute;
  left: 71px;
  top: 10px;
  img {
    width: 100%;
  }
}
.avue-tabs {
  padding: 0;
  position: relative;
  height:auto;
}
.avue-view {
  width: 100%;
  height: 97%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
